import React from 'react';
import { PageSection, SiteData } from '../../../types';
import { Calendar, ArrowRight, ShieldCheck, Clock, Award } from 'lucide-react';

interface SectionProps {
  section: PageSection;
  siteData: SiteData;
  onNavigate?: (slug: string) => void;
}

export const ReservationCtaSection: React.FC<SectionProps> = ({
  section,
  siteData,
  onNavigate,
}) => {
  const content = section.content || {};
  const style = section.style || {};

  const badge = content.badge || 'ERKEN REZERVASYON FIRSATLARI';
  const title = content.title || 'Bu Sezon Turkuaz Sularda Yerinizi Ayırın';
  const description =
    content.description ||
    'İstediğiniz tarihler ve rota için hemen ön talep formunu doldurun, uzman charter danışmanlarımız 30 dakika içinde size özel teklifle dönüş yapsın.';
  const buttonText = content.buttonText || 'Rezervasyon Talebi Oluştur';
  const buttonLink = content.buttonLink || '/rezervasyon';

  const bgColor = style.backgroundColor || '#032030';
  const textColor = style.textColor || '#FFFFFF';
  const accentColor = siteData.settings?.accentColor || '#00A6FB';

  return (
    <section
      className="py-20 px-4 sm:px-6 lg:px-8 text-center relative overflow-hidden"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="max-w-4xl mx-auto space-y-6 relative z-10">
        {badge && (
          <div
            className="inline-block px-4 py-1 rounded-full text-xs font-extrabold tracking-wider uppercase bg-white/10 border border-white/20 backdrop-blur-md"
            style={{ color: accentColor }}
          >
            {badge}
          </div>
        )}

        <h2 className="text-3xl sm:text-5xl font-black tracking-tight leading-tight">
          {title}
        </h2>

        <p className="text-sm sm:text-base text-slate-300 max-w-2xl mx-auto leading-relaxed">
          {description}
        </p>

        {/* Benefits Row */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4 max-w-2xl mx-auto text-left">
          <div className="flex items-center gap-3 p-3 rounded-2xl bg-white/5 border border-white/10 text-xs">
            <Award className="w-5 h-5 text-cyan-400 shrink-0" />
            <span>En İyi Fiyat Garantisi</span>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-2xl bg-white/5 border border-white/10 text-xs">
            <Clock className="w-5 h-5 text-cyan-400 shrink-0" />
            <span>30 Dk Hızlı Geri Dönüş</span>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-2xl bg-white/5 border border-white/10 text-xs">
            <ShieldCheck className="w-5 h-5 text-cyan-400 shrink-0" />
            <span>Bakanlık Onaylı Belgeli</span>
          </div>
        </div>

        {/* Action Button */}
        <div className="pt-6">
          <button
            type="button"
            onClick={() => onNavigate && onNavigate(buttonLink)}
            className="px-8 py-4 rounded-2xl font-bold text-sm sm:text-base text-white shadow-2xl hover:scale-105 transition-all duration-200 inline-flex items-center gap-2"
            style={{ backgroundColor: accentColor }}
          >
            <Calendar className="w-5 h-5" />
            <span>{buttonText}</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
